/**
 * Notifications-domain mutations — writes for the notification feed
 * (`useNotifications.ts`) go through the REST client (kronos-api).
 * See docs/superpowers/specs/2026-07-06-china-p2-client-seam-design.md.
 */
import { apiPut } from './restClient';

// --- notifications/{uid}/items (useNotifications.ts) ---
export async function markNotificationRead(uid: string, notificationId: string): Promise<void> {
  await apiPut(`/notifications/${uid}/items/${notificationId}`, { read: true });
}

export async function markAllNotificationsRead(uid: string, ids: string[]): Promise<void> {
  if (ids.length === 0) return;

  // ponytail: sequential PUT loop, no batch endpoint — idempotent, so a
  // partial failure just leaves some unread (retried on the next call).
  for (const id of ids) {
    await apiPut(`/notifications/${uid}/items/${id}`, { read: true });
  }
}
